// key is filename for templates or autogenerated path fo static pages

const isCs = process.env.GATSBY_APP_TYPE === 'cs'

console.log('process.env.GATSBY_APP_TYPE', process.env.GATSBY_APP_TYPE)

// eslint-disable-next-line no-multi-assign
module.exports = exports = {
  '/': {
    menu: {
      // absolute: true,
    },
    to: {
      cs: '/',
      en: '', // auto prepend with /en
    },
    footerBox: {
      en: 'contact',
    },
    metaDesc: {
      cs: isCs
        ? 'ATC pro vzdělávání a rozvoj. Vzdělávání v Metodě instrumentálního uvědomování (MIU), nabídka kurzů.'
        : 'Myslenie pre život & ATC pro vzdělávání a rozvoj. Vzdelávanie v Metóde inštrumentálneho uvedomovania (MIU), ponuka kurzov.',
      en: isCs
        ? 'ATC for Education & Development. Education in the Method of Instrumental Awareness (MIA), open courses.'
        : 'Myslenie & ATC for Education and Development. Education in the Method of Instrumental Awareness (MIA), open courses.',
    },
  },
  '/blog': {
    to: {
      cs: '/aktuality',
      en: '/blog',
    },
    footerBox: {
      en: 'contact',
    },
    metaDesc: {
      cs: isCs
        ? 'Aktuální dění v MIU v Česku i zahraničí. Novinky, konference, události.'
        : 'Aktuálne dianie v MIU na Slovensku aj v zahraničí. Novinky, konferencie, podujatia.',
      en: isCs
        ? 'News about MIA in the Czech Republic & abroad. News, conferences, events.'
        : 'News about MIA in the Slovak Republic & abroad. News, conferences, events.',
    },
  },
  '/about': {
    to: {
      cs: '/o-nas',
      en: '/about-us',
    },
    footerBox: {
      en: 'contact',
    },
    metaDesc: {
      cs: isCs
        ? 'Kdo jsme a co děláme. Tým ATC, spolupracovníci a partneři. Výroční zprávy. Dokumenty ke stažení.'
        : 'Kto sme a čomu sa venujeme. Tím Myslenie & ATC, spolupracovníci a partneri. Výročné správy. Dokumenty na stiahnutie.',
      en: isCs
        ? 'Who we are & what we do. ATC team, its associates and partners. Annual reports. Documents to download.'
        : 'Who we are & what we do. Myslenie & ATC team, its associates and partners. Annual reports. Documents to download.',
    },
  },
  '/materials': {
    to: {
      cs: '/miu-materialy',
    },
    footerBox: 'contact',

    metaDesc: isCs
      ? 'Materiály k Metodě instrumentálního uvědomování (MIU)'
      : 'Materiály k Metóde inštrumentálneho uvedomovania (MIU)',
  },
  '/collaborators': {
    to: {
      cs: isCs ? '/skoly-lektori' : '/spolupracujeme',
      en: '/schools-and-mediators',
    },
    footerBox: 'missing',
    footerBoxBg: 'bgGrey',
    metaDesc: {
      cs: isCs
        ? 'Kde působíme a kde se využívá MIU'
        : 'Kde pôsobíme a kde sa využíva MIU',
      en: 'Where we operate and MIA is used',
    },
  },
  '/projects': {
    to: {
      cs: isCs ? '/o-projektech' : '/projekty',
      en: '/about-projects',
    },
    footerBox: {
      cs: 'projects',
      en: 'contact',
    },
    metaDesc: {
      cs: isCs
        ? 'Projektová práce ATC při implementaci MIU'
        : 'Projektová práca Myslenie & ATC pri implementácii MIU',
      en: isCs
        ? 'ATC project work in the implementation of MIA'
        : 'Project work by Myslenie & ATC on the implementation of MIA',
    },
  },
  '/methods': {
    to: {
      cs: isCs ? '/o-metode' : '/miu',
      en: '/mia',
    },
    footerBox: {
      cs: 'tasting',
      en: 'contact',
    },
    metaDesc: {
      cs: isCs
        ? 'Informace o Metodě instrumentálního uvědomování, jejích přínosech a uplatnění'
        : 'Informácie o Metóde inštrumentálneho uvedomovania, jej prínosoch a uplatnení',
      en:
        'Information about the Method of Instrumental Awareness, its benefits, and applications',
    },
  },
  '/methods/feuerstein': {
    to: {
      cs: '/o-metodach/zivot-reuvena-feuersteina',
    },
    footerBox: 'tasting',
    metaDesc:
      'Dozvěďte se více o teoretických východiscích prof. R. Feuersteina, jeho životě i blíže o jednotlivých metodách FIE.',
  },
  '/methods/approach': {
    to: {
      cs: '/o-metodach/feuersteinuv-pristup',
    },
    footerBox: 'tasting',
    metaDesc:
      'Dozvěďte se více o teoretických východiscích prof. R. Feuersteina, jeho životě i blíže o jednotlivých metodách FIE.',
  },
  '/methods/theory': {
    to: {
      cs: '/o-metodach/teoreticka-vychodiska',
    },
    footerBox: 'tasting',
    metaDesc:
      'Dozvěďte se více o teoretických východiscích prof. R. Feuersteina, jeho životě i blíže o jednotlivých metodách FIE.',
  },
  '/methods/lpad': {
    to: {
      cs: '/o-metodach/lpad',
    },
    footerBox: 'tasting',
    metaDesc:
      'Dozvěďte se více o teoretických východiscích prof. R. Feuersteina, jeho životě i blíže o jednotlivých metodách FIE.',
  },
  '/methods/miu': {
    to: {
      cs: '/o-metodach/miu',
    },
    footerBox: 'tasting',
    metaDesc: 'Dozvěďte se více o Metodě instrumentálního uvědomování (MIU)',
  },
  '/methods/enrichment': {
    to: {
      cs: '/o-metodach/instrumentalni-obohacovani',
    },
    footerBox: 'tasting',
    metaDesc:
      'Dozvěďte se více o teoretických východiscích prof. R. Feuersteina, jeho životě i blíže o jednotlivých metodách FIE.',
  },
  '/courses': {
    to: {
      cs: isCs ? '/nabizene-kurzy' : '/kurzy-a-podujatia',
    },
    metaDesc: isCs
      ? 'Aktuální nabídka vzdělávacích programů ATC - kurzů, ochutnávek a seminářů MIU, termíny konferencí a dalších akcí'
      : 'Aktuálna ponuka vzdelávacích programov Myslenie & ATC – kurzov, ochutnávok a seminárov MIU, termíny konferencií a ďalších podujatí',
  },
  '/courses-headless': {
    to: {
      cs: '/courses-headless',
    },
    ...(!isCs && {
      metaDesc: 'Myslenie pre život & ATC pro vzdělávání a rozvoj',
    }),
  },
  '/collaborators-headless': {
    to: {
      cs: '/collaborators-headless',
      en: '/collaborators-headless',
    },
    ...(!isCs && {
      metaDesc: {
        cs: 'Myslenie pre život & ATC pro vzdělávání a rozvoj',
        en:
          'Myslenie & ATC for Education and Development. Education in the Method of Instrumental Awareness (MIA).',
      },
    }),
  },
  '/journey': {
    to: {
      cs: '/cesta-lektora',
    },
    footerBox: 'supervision',
    footerBoxBg: 'bgGrey',
    metaDesc: isCs
      ? 'Jaké jsou možnosti vzdělávání a jak vypadá průběžná metodická podpora lektorů MIU'
      : 'Aké sú možnosti vzdelávania a ako vyzerá priebežná metodická podpora lektorov MIU',
  },
  '/thanks': {
    to: {
      cs: '/prihlaseni-uspesne',
    },
    footerBox: 'contact',
    metaDesc: isCs
      ? 'ATC pro vzdělávání a rozvoj'
      : 'Myslenie pre život & ATC pro vzdělávání a rozvoj',
  },
  '/styles': {
    to: {
      cs: '/style-guide',
    },
  },
  '/temp': {
    to: {
      cs: '/temp',
    },
  },
  PostTemplate: {
    to: {
      cs: '/aktuality',
      en: '/blog',
    },
    withSlugs: true, // all template needs slugs
    metaDesc: {
      cs: '',
      en: '',
    },
    footerBox: {
      en: 'contact',
    },
  },
  ProjectTemplate: {
    to: {
      cs: '/o-projektech',
      en: '/about-projects',
    },
    withSlugs: true, // all template needs slugs
    footerBox: {
      cs: 'projects',
      en: 'contact',
    },
    metaDesc: {
      cs: '',
      en: '',
    },
  },
  CourseTemplate: {
    to: {
      cs: isCs ? '/nabizene-kurzy' : '/kurzy-a-podujatia',
    },
    withSlugs: true, // all template needs slugs
    footerBox: 'tasting',
    metaDesc: {
      cs: '',
      en: '',
    },
  },
  '/404': {
    footerBox: 'none',
    to: {
      cs: '/404',
      // en: '/404',
    },
  },
  '/404.html': {
    footerBox: 'none',
    to: {
      cs: '/404',
      // en: '/404',
    },
  },
}
